import * as React from 'react';

interface IEmailProps {
  email: string;
}

export class Email extends React.Component<IEmailProps> {
  public render() {
    return (
      <a href={'mailto:' + this.props.email}>{this.props.email}</a>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/components/Email/index.tsx